<scope-ui-tabs
  fontSize="13px"
  (onSelect)="onSelect($event)"
  *ngIf="tab">
  <scope-ui-tab
    #quantityTab
    tabTitle="Scope by quantity"
    routeLink="quantity"
    [active]="tab === 'quantity'">
    <iframe
      *ngIf="quantityTab.active"
      class="app-frame"
      [src]="baseJsUrl | safe"></iframe>
  </scope-ui-tab>
  <scope-ui-tab
    #financeTab
    tabTitle="Finance Reporting"
    routeLink="finance"
    [active]="tab === 'finance'"
    requiredPrivilege="DASHBOARD_FINANCE_REPORTING__VIEW">
    <finance-component />
  </scope-ui-tab>
  <scope-ui-tab
    #downloadsTab
    tabTitle="Report Downloads"
    routeLink="downloads"
    [active]="tab === 'downloads'"
    requiredPrivilege="DASHBOARD_REPORT_DOWNLOADS__VIEW">
    <iframe
      *ngIf="downloadsTab.active"
      class="app-frame"
      [src]="baseJsUrl | safe"></iframe>
  </scope-ui-tab>
</scope-ui-tabs>
